import styled from "styled-components";
import {animations, colors, devices, fonts, sizes} from "../../utils/styled/_variables.styled";
import {InfiosLanguageSelectorWrapper} from "../LanguageSelector/LanguageSelector.style";
import "../../base/styled/_typograhpy.style";

export const FooterLanguageWrapper = styled.div`
    position: relative;
    display: flex;
    margin: 0 0 36px;
    max-height: 25px;

    @media ${devices.mobileAndTablet} {
        margin: 0;
    }

    .label-medium {
      @media ${devices.mobileAndTablet} {
        display: grid;
      }
    }

    ${InfiosLanguageSelectorWrapper} {
      margin-left: 0;
    }

    .select {
      &__menu {
        display: flex;
        position: absolute;
        z-index: 200;
        top: 20px;
        left: 10px;
        height: auto;

        @media ${devices.mobileAndTablet} {
          display: grid;
          bottom: 20px;
          width: 100%;
          min-width: 93px;
          top: auto;
      }
    }

    &__control {

      .select__value-container {
        padding-left: 0;
        padding-right: 0;
      }

      .select__indicator.select__dropdown-indicator {
        margin-right: 10px;
      }

      &:hover {
        .select__single-value {
          transition: ${animations.buttonLink};
          color: ${colors.blueHover};
          opacity: 1;
        }
        svg {
            opacity: 1;
            path {
              transition: ${animations.buttonLink};
              fill: ${colors.blueHover};
            }
        }
      }
      &:active {
          color: ${colors.bluePressed};

          svg {
              path {
                  fill: ${colors.bluePressed}
              }
          }
        }
    }
  }
`;

const FooterBar = styled.footer`
  min-height: 324px;
  background: ${colors.darkGrayBlue};
  position: relative;
  overflow: hidden;


  @media ${devices.desktop} {
    padding-left: 96px;
    padding-right: 96px;
  }

  @media ${devices.mobileAndTablet} {
    padding-left: 20px;
    padding-right: 20px;
  }

  .footer {
    &__content {
      margin-right: auto;
      margin-left: auto;
      max-width: ${sizes.desktop - 1}px;
    }

    &__elements {
      min-height: 143px;
      display: flex;
      flex-wrap: wrap;
      margin: 0px 0px 36px;
      padding-top: 64px;
      row-gap: 36px;

      @media ${devices.mobileAndTablet} {
        display: grid;
        margin: 0px 0px 36px 0px;
        row-gap: 36px;
        padding-top: 29px;
      }

      .footer__logo {
        width: 88.619px;
        height: 35.48px;
        margin: 4px 75px 4px 0px;

        @media ${devices.mobileAndTablet} {
          margin: 0;
          width: 114.952px;
          height: 46.843px;
        }
      }

      .container__links {
        display: flex;
        flex-wrap: wrap;
        margin-right: auto;
        column-gap: 40px;

        a {
          color: ${colors.white};
          font-family: ${fonts.AeonikMono};
          font-size: 16.371px;
          font-style: normal;
          font-weight: 400;
          line-height: 15.094px;
          letter-spacing: -0.327px;
          text-transform: uppercase;
        }

        @media ${devices.mobileAndTablet} {
          display: grid;
          justify-items: flex-start;
          margin-left: 0;
          margin-top: 17px;

          a {
            line-height: 25.539px;
          }
        }
      }

      .container__social {
        display: flex;
        flex-wrap: wrap;
        column-gap: 31.3px;
        margin-left: 32px;

        @media ${devices.mobileAndTablet} {
          margin-left: 0;
          column-gap: 12px;
          row-gap: 24px;
        }

        a:hover{
          opacity: 1;
        }

        img {
          filter: grayscale(1) invert(1) brightness(2);
          transition: filter 0.5s;
          &:hover {
            opacity: 1;
            filter: none;
          }
        }
      }

      .container__sublinks {
        display: flex;
        flex-wrap: wrap;
        column-gap: 24px;
        width: 100%;
        margin-left: 0;

        a {
          color: ${colors.white};
          font-family: ${fonts.AeonikPro};
          font-size: 16.371px;
          font-style: normal;
          font-weight: 400;
          line-height: 15.094px;
          letter-spacing: -0.327px;
        }

        @media ${devices.mobileAndTablet} {
          display: grid;
          justify-items: flex-start;
          margin-left: 0;

          a {
            line-height: 22.756px;
          }
        }

      }
    }

    &__separator {
      position: absolute;
      height: 1px;
      border-width: 0px;
      background: ${colors.white};
      opacity: 0.32;
      left: 0;
      width: -webkit-fill-available;

      @media ${devices.mobileAndTablet} {
        display: none;
      }
    }

    &__copyrights {
      display: flex;
      flex-wrap: wrap;
      margin-right: auto;
      margin-left: auto;
      max-width: ${sizes.desktop - 1}px;
      padding: 35.48px 0px 36px;
      flex-direction: column;

      p, h2, h3 {
        color: ${colors.white};
        font-family: ${fonts.AeonikPro};
        font-size: 16.371px;
        font-style: normal;
        font-weight: 400;
        line-height: 15.094px;
        letter-spacing: -0.327px;
				min-height: unset;
      }
			p{
				font-size:19px!important;
			}

      @media ${devices.mobileAndTablet} {
        padding: 18px 24px 21.88px 0px;
      }

    }
  }

`;

export { FooterBar };
